import React from "react";
import Spinner from "react-webpack-spinner";

class EmailAddress extends React.Component {
  componentWillMount() {
    this.props.onReset();
  }

  render() {
    const { isRequestingPassword, requestedPassword, onSend } = this.props;

    if (isRequestingPassword) {
      return (
        <div className="flex-1-1 has-text-centered">
          <Spinner width={32} height={32} color="#000" />
        </div>
      );
    }

    if (requestedPassword) {
      return (
        <div className="content">
          <h1 className="title">Mail versendet</h1>
          <p>
            Bitte sehen Sie in Ihrem Mail-Postfach nach, dort werden Sie in
            Kürze weitere Hinweise finden, um Ihr Passwort zurückzusetzen.
          </p>
        </div>
      );
    }

    return (
      <div className="content">
        <h1 className="title">Neues Passwort erstellen</h1>

        <p>
          Falls Sie Ihr Passwort vergessen haben, tragen Sie hier bitte Ihre
          E-Mail-Adresse ein, Sie bekommen dann eine E-Mail mit weiteren
          Hinweisen zugeschickt.
        </p>
        <input
          placeholder="E-Mail-Adresse"
          className="input is-medium"
          ref="email"
          type="email"
        />
        <button
          className="button is-success"
          onClick={() => onSend(this.refs.email.value)}
        >
          Absenden
        </button>
      </div>
    );
  }
}

export default EmailAddress;



/** WEBPACK FOOTER **
 ** ./src/components/EmailAddress.jsx
 **/